import React from 'react';
import { LegalEntityTypeList } from '../../../../../../slices/marketplace/timeline/models/enums/legal-enity-type';
import { useStateSelector } from '../../../../../../store/selectors';
import { EngagementPractice } from '../../../../../../slices/marketplace/timeline/models/engagement-practice';
import './SellerLegalInfoSection.scss';

const EMPTY_VALUE = '—';

interface LabelValueRowProps {
    label: string;
    value: React.ReactNode;
}

const LabelValueRow = ({ label, value }: LabelValueRowProps) => (
    <div className="seller-legal-info-section__row">
        <div className="seller-legal-info-section__label">{label}</div>
        <div className="seller-legal-info-section__value">{value}</div>
    </div>
);

const hasPracticeAddress = (practice: EngagementPractice) =>
    !!(practice.address || practice.city || practice.state || practice.zipCode);

const renderPracticeAddress = (practice: EngagementPractice) => {
    const cityStateZip = [practice.city, practice.state, practice.zipCode].filter(Boolean).join(' ');
    return (
        <>
            {practice.address && <div>{practice.address}</div>}
            {cityStateZip && <div>{cityStateZip}</div>}
        </>
    );
};

export const SellerLegalInfoSection = () => {
    const practices = useStateSelector(
        (state) => state.opportunities.selectedOpportuity?.practices
    );

    if (!practices || practices.length === 0) {
        return null;
    }

    return (
        <div className="seller-legal-info-section">
            <div className="seller-legal-info-section__title">Seller Legal Information</div>

            <div className="seller-legal-info-section__subsection">
                {practices.map((practice, index) => {
                    const entityTypeName =
                        LegalEntityTypeList.find((x) => x.id === practice.entityType)?.name ?? '';
                    return (
                        <div key={practice.practiceId} className="seller-legal-info-section__entry">
                            {index > 0 && <div className="seller-legal-info-section__divider" />}
                            <LabelValueRow label="Entity Name" value={practice.entityName || EMPTY_VALUE} />
                            <LabelValueRow label="Owner Name" value={practice.ownerName || EMPTY_VALUE} />
                            <LabelValueRow label="Entity Type" value={entityTypeName || EMPTY_VALUE} />
                            <LabelValueRow
                                label="State of Registration"
                                value={practice.stateOfRegistration || EMPTY_VALUE}
                            />
                            <LabelValueRow label="D/B/A" value={practice.practiceName || EMPTY_VALUE} />
                            <LabelValueRow
                                label="Registered Address"
                                value={hasPracticeAddress(practice) ? renderPracticeAddress(practice) : EMPTY_VALUE}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
